import { PayloadAction } from '@reduxjs/toolkit';
import { PersonalDevelopmentPlan } from 'types/pdp';

interface PDPState {
  items: PersonalDevelopmentPlan[];
  fullData: Record<number, PersonalDevelopmentPlan>;
}

export function updateActionStepCompletionInState(
  state: PDPState,
  action: PayloadAction<
    unknown,
    string,
    { arg: { id: number; actionStepId: number; isAchieved: boolean } }
  >,
  isAchieved?: boolean,
) {
  const { actionStepId, id: pdpId } = action.meta.arg;
  const targetValue =
    isAchieved !== undefined ? isAchieved : action.meta.arg.isAchieved;

  const itemIndex = state.items.findIndex((item) => item.id === pdpId);
  if (itemIndex !== -1) {
    state.items[itemIndex] = {
      ...state.items[itemIndex],
      developmentNeeds: state.items[itemIndex].developmentNeeds.map((need) => ({
        ...need,
        actionSteps: need.actionSteps.map((step) =>
          step.id === actionStepId
            ? { ...step, isAchieved: targetValue }
            : step,
        ),
      })),
    };
  }

  if (state.fullData[pdpId]) {
    state.fullData[pdpId] = {
      ...state.fullData[pdpId],
      developmentNeeds: state.fullData[pdpId].developmentNeeds.map((need) => ({
        ...need,
        actionSteps: need.actionSteps.map((step) =>
          step.id === actionStepId
            ? { ...step, isAchieved: targetValue }
            : step,
        ),
      })),
    };
  }
}
